import React from 'react';

/**
 * Captura erros de render de qualquer tela e mostra um fallback amigável,
 * evitando a "tela branca" (o app não tinha nenhum ErrorBoundary).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary capturou um erro:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
          <div className="text-center max-w-md">
            <h1 className="text-xl font-semibold text-slate-800 mb-2">Algo deu errado nesta tela</h1>
            <p className="text-sm text-slate-500 mb-5">
              Ocorreu um erro inesperado. Seus dados estão seguros — tente recarregar a página.
            </p>
            <button
              onClick={this.handleReload}
              className="px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-primary/90 transition-colors"
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
